import Vue from 'vue';
import IconTemplate from './iconTemplate.vue';

Vue.component('icon', IconTemplate);
